var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 12.7942C24.0001 11.9673 23.9201 11.1137 23.7867 10.3135H12.2368V15.0348H18.852C18.5853 16.5552 17.705 17.8889 16.398 18.7425L20.3458 21.8101C22.6664 19.6494 24.0001 16.5019 24.0001 12.7942Z",
    fill: "#4280EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2367 24.7445C15.5443 24.7445 18.3184 23.6508 20.3457 21.7836L16.3979 18.7428C15.3042 19.4896 13.8905 19.9164 12.2367 19.9164C9.03581 19.9164 6.34171 17.7558 5.35477 14.875L1.30029 17.9959C3.38088 22.1304 7.5954 24.7445 12.2367 24.7445Z",
    fill: "#34A353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35484 14.8481C4.84803 13.3276 4.84803 11.6738 5.35484 10.1534L1.30037 7.00586C-0.433456 10.4735 -0.433456 14.5547 1.30037 17.9956L5.35484 14.8481Z",
    fill: "#F6B704"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2367 5.112C13.9705 5.08533 15.6777 5.75219 16.9314 6.95252L20.4257 3.43153C18.2117 1.35094 15.2776 0.230627 12.2367 0.257301C7.5954 0.257301 3.38088 2.87137 1.30029 7.00587L5.35477 10.1534C6.34171 7.24594 9.03581 5.112 12.2367 5.112Z",
    fill: "#E54335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.257e0a11fac3b133f1e4c1e06182b295.svg";
export { ForwardRef as ReactComponent };